import React from 'react'
import Spinner from '../../assets/svgs/spinner.svg'
import PropTypes from 'prop-types'
import './buttonSpinnerLoader.scss'

/** Spinner Loader  */
const ButtonSpinnerLoader = ({ className, variant, ...props }) =>
   <div className={`Suc-button-spinner-loader ${className} Suc-${variant}`} {...props}>
    <Spinner/>
 </div>

ButtonSpinnerLoader.propTypes = {
  /** variant of spinner */
  variant: PropTypes.oneOf(['stand-alone', 'button-loader']),
  /** custom classname */
  className: PropTypes.string
}

ButtonSpinnerLoader.defaultProps = {
  variant: 'stand-alone',
  className: ''
}

export default ButtonSpinnerLoader
